import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useUserDeliveryInfo } from '~/contexts/InventoryContext';

const useShowZeroResults = (zeroVehicles: boolean) => {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { isDeliveryAllowed } = useUserDeliveryInfo() ?? {};
  const hideFreeShippingVehicles =
    !isDeliveryAllowed && (appliedFilters?.isFreeDelivery ?? false);

  return zeroVehicles || hideFreeShippingVehicles;
};

export default useShowZeroResults;
